import { useCallback, useState } from 'react';
import type { PickedContact } from '../../../../lib/contact-references';

// The composer's selected-contacts state — the contacts picked via "+ Contact" that will ride the
// next send as `references.contacts`. De-dupes by contact id so tapping the same row twice is a no-op.
export function useContactReferences() {
  const [pickedContacts, setPickedContacts] = useState<PickedContact[]>([]);

  const addContact = useCallback((contact: PickedContact) => {
    setPickedContacts((prev) => (prev.some((p) => p.id === contact.id) ? prev : [...prev, contact]));
  }, []);

  const removeContact = useCallback((id: string) => {
    setPickedContacts((prev) => prev.filter((p) => p.id !== id));
  }, []);

  const clearContacts = useCallback(() => setPickedContacts([]), []);

  return { pickedContacts, addContact, removeContact, clearContacts };
}
